import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

const siteKey = process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY;

export const TurnstileWidget = ({ onSuccess }) => {
  if (!siteKey) {
    console.error("Cloudflare Turnstile Site Key is not configured. Please set REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY in your .env file.");
    return null;
  }

  return (
    <Turnstile
      siteKey={siteKey}
      onSuccess={onSuccess}
      onError={(err) => console.error("Turnstile error:", err)}
      options={{
        size: "invisible",
      }}
    />
  );
};